import {useLocation} from "react-router";
import {useIntl} from "react-intl";
import {usePageTitle} from "../hooks";
import {parse} from "../errorPageUrl";
import ErrorDisplay, {ERROR_REASON_MESSAGES} from "./ErrorDisplay";

export default function ErrorPage() {
    const location = useLocation();
    const intl = useIntl();

    const {id, code, path} = parse(location.search);

    const reason = intl.formatMessage(ERROR_REASON_MESSAGES[id]);

    usePageTitle(reason);

    return <ErrorDisplay code={code} reason={id} path={path} />;
}
